import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { splitProfileListService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useUpdateSplitProfileDefaultMutation = (onSuccess = () => {}) => {
	const dispatch = useDispatch();

	return useMutation(
		({
			agentId,
			splitProfileId,
			isDefault,
		}: {
			agentId: string;
			splitProfileId: string;
			isDefault: boolean;
		}) => {
			dispatch(uiActions.showSpinnerOverlay());
			return splitProfileListService.updateSplitProfileDefault({
				agentId,
				splitProfileId,
				isDefault,
			});
		},
		{
			onSuccess() {
				onSuccess?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
		},
	);
};

export default useUpdateSplitProfileDefaultMutation;
